import {
  type DbObject,
  ObjectType,
  ObjectStatus,
  StartAtType,
  StartAtSubType,
} from "@/db/schema"

// Re-export DB types that features need
export type { DbObject }
export { ObjectType, ObjectStatus, StartAtType, StartAtSubType }

/**
 * Create a new task with sensible defaults.
 * Date fields use dayjs().utc().valueOf().toString() — stringified ms timestamp.
 */
export function createTaskDefaults(
  overrides: Partial<DbObject> & { id: string },
): DbObject {
  return {
    type: ObjectType.Task,
    title: "",
    note: "",
    parentPath: "",
    index: 0,
    status: ObjectStatus.Unfinished,
    tags: [],
    isDeleted: 0,
    owner: "",
    realmId: "",
    createdAt: "",
    createdBy: "",
    fullTextIndex: [],
    ...overrides,
  }
}
